import { initTheme } from "./components/Header.js";
import { initGoogleAnalytics } from "./lib/analytics.js";
import { createDataStore } from "./lib/dataStore.js";
import { createRouter } from "./router.js";
import "./styles.css";

const activeFavicon = new URL("./assets/favicons/favicon.ico", import.meta.url)
  .href;

// Apply stored theme before first render to avoid flash
initTheme();

const faviconLink = document.querySelector("#app-favicon");
if (faviconLink) faviconLink.href = activeFavicon;

const root = document.querySelector("#app");
const store = createDataStore();
const router = createRouter({ root, store });

initGoogleAnalytics();
router.start();

function loadHeaderCtaShimmer() {
  import("./components/headerCtaShimmer.js")
    .then(({ initHeaderCtaShimmer }) => {
      initHeaderCtaShimmer({ delayMs: 5000 });
    })
    .catch(() => {
      // non-critical visual enhancement
    });
}

function loadHeaderCtaVisibility() {
  import("./components/headerCtaVisibility.js")
    .then(({ initHeaderCtaVisibility }) => {
      initHeaderCtaVisibility();
    })
    .catch(() => {
      // non-critical visual enhancement
    });
}

function loadDeferredHeaderEnhancements() {
  loadHeaderCtaVisibility();
  loadHeaderCtaShimmer();
}

if ("requestIdleCallback" in window) {
  window.requestIdleCallback(loadDeferredHeaderEnhancements, { timeout: 3000 });
} else {
  window.setTimeout(loadDeferredHeaderEnhancements, 1200);
}
